<!--
9 Jun 2025: Marketo is going away and we can't deliver these ebooks without it,
so disable this module until we have the Hubspot implementation up and running.
-->

<template>
  <div>
    <!-- GatedContentDownloadModule -->
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
  },
}
</script>
